import { render, staticRenderFns } from "./CorporateCustomerList.vue?vue&type=template&id=5782cd52&scoped=true&"
import script from "./CorporateCustomerList.vue?vue&type=script&lang=js&"
export * from "./CorporateCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./CorporateCustomerList.vue?vue&type=style&index=0&id=5782cd52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5782cd52",
  null
  
)

export default component.exports